import { User } from './../../calendar/event-form/label-selector/label-selector.component';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ProfilehelperDD } from 'app/shared/common/helper/personaldetails-helper';
import { DataService } from 'app/shared/common/helper/http-service';
import { Configuration } from 'app/app.configuration';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import * as Parse from 'parse';
@Component({
    selector: 'register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})

export class RegisterComponent implements OnInit {

    selectedRole: any;
    newId: any;
    roleId: any;
    locationList = [];
    roleList = [];
    departmentList = [];
    reportingtoList = [];
    reportList = [];
    registerformErrors: any;
    filteredOptions: Observable<any[]>;
    myControl = new FormControl();
    organisationLists = [];
    registerForm: FormGroup;
    profileId: any;
    tenantId: any;
    username: any;
    profileName: string;
    industryId: any;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */

    constructor(private router: Router,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private parseService: ParseService,
        private toastr: ToastrService,
        public dialog: MatDialog,
        private queryInterface: QueryInterface,
        private _helper: ProfilehelperDD,
        private dataService: DataService,
        private configuration: Configuration,
        private storageConfiguration: StorageConfiguration,
        private dialogRef: MatDialogRef<RegisterComponent>
    ) {
        // Configure the layout
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: false,
                },
                toolbar: {
                    hidden: false
                },
                footer: {
                    hidden: false
                },
                sidepanel: {
                    hidden: false
                }
            }
        };

        this.reportingtoList = this._helper.reportingtoEmployee;
        this.registerformErrors = {
            firstName: {},
            lastName: {},
            officialEmail: {},
            locationId: {},
            reporterId: {},
            departmentId: {},
            roleId: {},
            organisationId: {}
        };
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
        this.industryId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.industryId);
    }
    closeDialog(): void {
        this.dialogRef.close();
      }
    ngOnInit() {
        const emailRegEx = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
        this.getReportingTo();
        this.getRoles();
        this.getLocation();
        this.getDepartment();
        this.getOrganisation();
        this.registerForm = this._formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            officialEmail: ['', [Validators.required, Validators.email, Validators.pattern(emailRegEx)]],
            startTime: [''],
            organisationId: ['', Validators.required],
            locationId: ['', Validators.required],
            reporterId: ['', Validators.required],
            departmentId: ['', Validators.required],
            roleId: ['', Validators.required],
            isWebDesktop: [true]
        });
        this.registerForm.valueChanges.subscribe(() => {
            this.onFormValuesChanged('registerForm');
        });
    }

    async designation(event) {
        if (event.value.name == 'CEO' || event.value.name == 'General Manager' || event.value.name == 'HR' || event.value.name == 'Admin') {
            this.reportingtoList = this.reportingtoList.filter(x => x.role == 'Admin');
        } else {
            this.reportingtoList = this._helper.reportingtoEmployee;
            this.getReportingTo();
        }
    }

    nameChange(fname, lname) {
        fname = this.nameCapitalChange(fname);
        lname = this.nameCapitalChange(lname);

        this.registerForm.patchValue({
            firstName: fname,
            lastName: lname

        });
    }

    nameCapitalChange(event) {
        event = event.toLowerCase();
        return event.replace(/\b\w/g, l => l.toUpperCase());
    }

    async getRoles() {
        let TenantRole = this.parseService.instance.Object.extend('TenantRole');
        let tenantRole = new this.parseService.instance.Query(TenantRole);
        tenantRole.equalTo('tenantId', this.tenantId);
        tenantRole.ascending('displayName');
        await tenantRole.find().then(results => {
            if (results.length > 0) {
                results.forEach(element => {
                    var roleId = element.get('role').id;
                    var roleName = element.get('displayName');
                    if (roleName) {
                        this.roleList.push({ id: roleId, name: roleName });
                    }
                });
            }
            else {
                let rolesClass = this.parseService.instance.Object.extend('_Role');
                let roleQuery = new this.parseService.instance.Query(rolesClass);
                roleQuery.equalTo('isActive', true);
                roleQuery.ascending('name');
                roleQuery.find().then(results => {
                    results.forEach(element => {
                        var roleId = element.id;
                        var roleName = element.get('name')
                        this.roleList.push({ id: roleId, name: roleName });
                    });
                });
            }
        });
    }

    onFormValuesChanged(formgroup) {
        for (const field in this.registerformErrors) {
            if (!this.registerformErrors.hasOwnProperty(field)) {
                continue;
            }
            this.registerformErrors[field] = {};
            // Get the control
            if (formgroup == 'registerForm') {
                const control = this.registerForm.get(field);
                if (control && control.dirty && !control.valid) {
                    this.registerformErrors[field] = control.errors;
                }
            }
        }
    }

    async createUser(sessionToken) {
        var nameFirst = this.registerForm.value.firstName
        var nameLast = this.registerForm.value.lastName
        var userName = nameFirst.concat(' ' + nameLast);
        let user = this.parseService.instance.Object.extend('User');
        let createQuery = new user();
        let profile = this.parseService.instance.Object.extend('Profile');
        let profileClass = new profile();
        profileClass.id = this.profileId;
        createQuery.set('profile', profileClass);
        createQuery.set('firstName', nameFirst);
        createQuery.set('lastName', nameLast);
        createQuery.set('username', userName);
        createQuery.set('email', this.registerForm.value.officialEmail.toLowerCase());
        createQuery.set('password', 'SmartWork@123');
        createQuery.set('isActive', true);
        createQuery.set('employeeId', '');
        createQuery.set('tenantId', this.tenantId);
        createQuery.set('desktopVerified', false);
        createQuery.set('role', { __type: 'Pointer', className: '_Role', objectId: this.registerForm.value.roleId.id });
        await createQuery.signUp().then(async (data) => {
            this.newId = data.id;
            this.assignDefaultProject(this.newId);
            this.toastr.success('User Created Successfully');
            this.parseService.instance.User.become(sessionToken).then(() => {
                this.dialogRef.close({ saved: true });
            });
        }).catch((error) => {
            if (error.message === 'Account already exists for this username.') {
                this.toastr.error('Account already exists for this username.');
            } else if (error.message === 'Account already exists for this email address.') {
                this.toastr.error('Account already exists for this email address.');
            }
        });
    }

    async createProfile() {
        var nameFirst = this.registerForm.value.firstName;
        var nameLast = this.registerForm.value.lastName;
        var userName = nameFirst.concat(' ' + nameLast);
        const isWebDesktop = this.registerForm.value.isWebDesktop;

        let userClass = this.parseService.instance.Object.extend('_User');
        let userNameQuery = new this.parseService.instance.Query(userClass);
        userNameQuery.equalTo('username', userName);
        let res = await userNameQuery.find();
        if (res.length > 0) {
            this.toastr.warning('Account already exists for this username.');
            return;
        }

        let email = this.parseService.instance.Object.extend('_User');
        let emailQuery = new this.parseService.instance.Query(email);
        emailQuery.equalTo('email', this.registerForm.value.officialEmail);
        let result = await emailQuery.find();
        if (result.length > 0) {
            this.toastr.warning('Account already exists for this email address.');
            return;
        }

        let profile = this.parseService.instance.Object.extend('Profile');
        let createQuery = new profile();
        createQuery.set('firstName', nameFirst);
        createQuery.set('lastName', nameLast);
        createQuery.set('username', userName);
        createQuery.set('email', this.registerForm.value.officialEmail);
        createQuery.set('screenShot', true);
        createQuery.set('isMeeting', false);
        createQuery.set('keylogger', true);
        createQuery.set('tenantId', this.tenantId);
        createQuery.set('screenShotSyncTime', 300);
        createQuery.set('isWebDesktop', isWebDesktop);

        var location = new this.parseService.instance.Object('Location');
        location.id = this.registerForm.value.locationId;
        createQuery.set('location', location);
        var locationHistory = [];
        var currentlocation = this.locationList.filter(
            location => location.id == this.registerForm.value.locationId
        );
        let locationHistoryInfo = {
            id: this.registerForm.value.locationId,
            name: currentlocation[0].name,
            startDate: new Date(),
            endDate: '',
            isActive: true
        };
        locationHistory.push(locationHistoryInfo);
        createQuery.set('locationHistory', locationHistory);

        var department = new this.parseService.instance.Object('Department');
        department.id = this.registerForm.value.departmentId;
        createQuery.set('department', department);
        var departmentHistory = [];
        var currentDepartment = this.departmentList.filter(
            department => department.id == this.registerForm.value.departmentId
        );
        let departmentHistoryInfo = {
            id: this.registerForm.value.departmentId,
            name: currentDepartment[0].name,
            startDate: new Date(),
            endDate: '',
            isActive: true
        };
        departmentHistory.push(departmentHistoryInfo);
        createQuery.set('departmentHistory', departmentHistory);
        createQuery.set('role', { __type: 'Pointer', className: '_Role', objectId: this.registerForm.value.roleId.id });
        // var role = new this.parseService.instance.Object('_Role');
        // role.id = this.registerForm.value.roleId.id;
        // this.roleId = role.id;
        // createQuery.set('role', role);
        var roleHistory = [];
        var currentRole = this.roleList.filter(
            role => role.id == this.registerForm.value.roleId.id
        );
        let roleHistoryInfo = {
            id: this.registerForm.value.roleId.id,
            name: currentRole[0].name,
            startDate: new Date(),
            endDate: '',
            isActive: true
        };
        roleHistory.push(roleHistoryInfo);
        createQuery.set('roleHistory', roleHistory);

        var reportingTo = new this.parseService.instance.Object('Profile');
        reportingTo.id = this.registerForm.value.reporterId;
        createQuery.set('reportingTo', reportingTo);
        var reporterHistory = [];
        var currentReporting = this.reportingtoList.filter(
            reportingTo => reportingTo.id == this.registerForm.value.reporterId
        );
        let reportHistoryInfo = {
            id: this.registerForm.value.reporterId,
            name: currentReporting[0] ? currentReporting[0].name : '',
            startDate: new Date(),
            endDate: '',
            isActive: true
        };
        reporterHistory.push(reportHistoryInfo);
        createQuery.set('reporterHistory', reporterHistory);

        var organisation = new this.parseService.instance.Object('Organisation');
        organisation.id = this.registerForm.value.organisationId;
        createQuery.set('organisation', organisation);
        var organisationHistory = [];
        var currentOrganisation = this.organisationLists.filter(
            organisation => organisation.id == this.registerForm.value.organisationId
        );
        let organisationHistoryInfo = {
            id: this.registerForm.value.organisationId,
            name: currentOrganisation[0].name,
            startDate: new Date(),
            endDate: '',
            isActive: true
        };
        reporterHistory.push(organisationHistoryInfo);
        createQuery.set('organisationHistory', organisationHistory);
        createQuery.set('password', 'SmartWork@123');
        createQuery.set('isActive', true);
        createQuery.set('isLongLeave', false);
        createQuery.set('personalInfo', {});
        createQuery.set('skillSet', []);
        createQuery.set('resignationInfo', {});
        createQuery.set('profileImageInfo', {});
        createQuery.set('officialInfo', { 'startTime': '9:30 AM', 'officialEmail': this.registerForm.value.officialEmail });
        createQuery.set('systemInfo', {});
        createQuery.set('experienceInfo', []);
        // localStorage.clear();
        // sessionStorage.clear();
        createQuery.save().then(async (data) => {
            // this.parseService.instance.User.become(sessionToken);
            this.profileId = data.id;
            this.profileName = data.attributes.username;
            let department = data.get('department').get('name');
            const sessionToken = this.parseService.instance.User.current().getSessionToken();
            await this.createUser(sessionToken);
            this.createCustomAccess(this.profileId, department);
            this.sendRegisterAccountEmail(data);
        }).catch((error) => {
            if (error.message === 'Account already exists for this username.') {
                this.toastr.error('Account already exists for this username.');
            } else if (error.message === 'Account already exists for this email address.') {
                this.toastr.error('Account already exists for this email address.');
            }
        });
    }

    async createCustomAccess(profileId, department) {
        let CustomRoleSettings = this.parseService.instance.Object.extend('CustomRoleSettings');
        let createQuery = new CustomRoleSettings();
        createQuery.set('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
        let emploeeSettings = [
            {
                moduleName: "Employees",
                All: false,
                Assigned: true,
                None: false,
            },
            {
                moduleName: "Projects",
                All: false,
                Assigned: true,
                None: false,
            }
        ]
        let adminSettings = [
            {
                moduleName: "Employees",
                All: true,
                Assigned: false,
                None: false,
            },
            {
                moduleName: "Projects",
                All: true,
                Assigned: false,
                None: false,
            }
        ]
        if (department == 'Management') {
            createQuery.set('customRoles', adminSettings);
        }
        else {
            createQuery.set('customRoles', emploeeSettings);
        }
        createQuery.set('tenantId', this.tenantId);
        let data = await createQuery.save();
    }

    sendRegisterAccountEmail(result) {
        let data = {
            name: result.get('firstName') + ' ' + result.get('lastName'),
            email: result.get('officialInfo').officialEmail,
            password: 'SmartWork@123'
        }
        this.dataService.add(this.configuration.registerAccount, data).subscribe((data: any) => {
        });
    }

    async addUsertoRoleNamed() {
        var queryRel = new this.parseService.instance.Query('User');
        queryRel.equalTo('objectId', this.newId);
        await queryRel.find().then(users => {
            var user = users[0];
            this.addRelation(user).then(res => {

            });
        }).then((error) => {

        })
    }

    async addRelation(user) {
        var queryRel = new this.parseService.instance.Query('_Role');
        queryRel.equalTo('objectId', this.roleId);
        await queryRel.first().then((role) => {
            var relation = role.relation('users');
            relation.add(user);
            role.save().then((result) => {
            });
            return role;
        });
    }


    async getLocation() {
        let result = [];
        this.queryInterface.executeQuery(this.parseService, 'Location', [{ condition: 'equalTo', field: 'isActive', value: true }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
        { field: 'name', condition: 'descending' }]).then(results => {
            for (let i = 0; i < results.length; i++) {
                let jsonText = JSON.stringify(results[i]);
                let locationInfo = JSON.parse(jsonText);
                result.push({ id: locationInfo.objectId, name: locationInfo.name });
            }
            this.locationList = result;
        });
    }
    async getDepartment() {
        let result = [];
        this.queryInterface.executeQuery(this.parseService, 'TenantDepartment',
            [{ condition: 'equalTo', field: 'tenantId', value: this.tenantId }]).then(results => {
                if (results.length > 0) {
                    for (let department of results) {
                        this.departmentList.push({
                            id: department.get('department').id,
                            name: department.get('displayName'),
                        });
                    }
                }
                else {
                    this.queryInterface.executeQuery(this.parseService, 'Department', [{ condition: 'equalTo', field: 'isActive', value: true },
                    { field: 'name', condition: 'descending' }]).then(results => {
                        for (let i = 0; i < results.length; i++) {
                            let jsonText = JSON.stringify(results[i]);
                            let departmentInfo = JSON.parse(jsonText);
                            result.push({
                                id: departmentInfo.objectId,
                                name: departmentInfo.name
                            });
                        }
                        this.departmentList = result;
                    });
                }
            });
    }

    async getReportingTo() {
        let reportingToEmployee = true;
        await this.queryInterface.queryUserReporting(this.parseService, reportingToEmployee).then(results => {
            this.reportList = results;
        });
    }

    async getOrganisation() {
        let result = [];
        this.queryInterface.executeQuery(this.parseService, 'Organisation', [{ condition: 'equalTo', field: 'isActive', value: true }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
        { field: 'name', condition: 'descending' }]).then(results => {
            for (let i = 0; i < results.length; i++) {
                let jsonText = JSON.stringify(results[i]);
                let organisationInfo = JSON.parse(jsonText);
                result.push({
                    id: organisationInfo.objectId,
                    name: organisationInfo.name
                });
            }
            this.organisationLists = result;
        });
    }

    async assignDefaultProject(userId) {
        const departmentName = this.departmentList.find((dep) => dep.id === this.registerForm.value.departmentId);
        let queryInstance = this.parseService.instance.Object.extend('Project');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('defaultProject', true);
        query.equalTo('tenantId', this.tenantId);
        let res = await query.find();
        let projectId = res[0].id;

        let ProjectClass = this.parseService.instance.Object.extend('ProjectMembers');
        var projectDetails = new ProjectClass();
        projectDetails.set('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
        projectDetails.set('startDate', new Date());
        projectDetails.set('endDate', new Date());
        projectDetails.set('resourcesType', 'Fixed Non-Billable');
        projectDetails.set('username', this.profileName);
        projectDetails.set('isActive', true);
        projectDetails.set('isInvited', false);
        projectDetails.set('status', 'Assigned');
        projectDetails.set('role', departmentName.name);
        projectDetails.set('tenantId', this.tenantId);
        projectDetails.set('user', { __type: 'Pointer', className: '_User', objectId: userId });
        projectDetails.save();
    }

}

export interface userlists {
    value: string;
    viewValue: string;
}
